export const VUONG_TUONG_HUU_TU_THANG = [
  {
    chiId: 0,
    time: []
  },
  {
    chiId: 1,
    mua: 'Đông',
    muaCss: 'color_thuy',
    tk: 'Đại tuyết',
    time: [
      { min: 1, max: 10, canId: 9 },
      { min: 11, max: 30, canId: 10 }
    ],
    can: [
      ['Tướng', 'Tử', 'Tù', 'Hưu', 'Vượng'],
      ['Tướng', 'Tử', 'Tù', 'Hưu', 'Vượng']
    ]
  },
  {
    chiId: 2,
    mua: 'Đông',
    muaCss: 'color_thuy',
    tk: 'Tiểu hàn',
    time: [
      { min: 1, max: 9, canId: 10 },
      { min: 10, max: 12, canId: 8 },
      { min: 13, max: 30, canId: 6 }
    ],
    can: [
      ['Tướng', 'Tử', 'Tù', 'Hưu', 'Vượng'],
      ['Tử', 'Tù', 'Hưu', 'Vượng', 'Tướng'],
      ['Tù', 'Hưu', 'Vượng', 'Tướng', 'Tử']
    ]
  },
  {
    chiId: 3,
    mua: 'Xuân',
    muaCss: 'color_moc',
    tk: 'Lập Xuân',
    time: [
      { min: 1, max: 7, canId: 5 },
      { min: 8, max: 14, canId: 3 },
      { min: 15, max: 30, canId: 1 }
    ],
    can: [
      ['Tù', 'Hưu', 'Vượng', 'Tướng', 'Tử'],
      ['Hưu', 'Vượng', 'Tướng', 'Tử', 'Tù'],
      ['Vượng', 'Tướng', 'Tử', 'Tù', 'Hưu']
    ]
  },
  {
    chiId: 4,
    mua: 'Xuân',
    muaCss: 'color_moc',
    tk: 'Kinh trập',
    time: [
      { min: 1, max: 10, canId: 1 },
      { min: 11, max: 30, canId: 2 }
    ],
    can: [
      ['Vượng', 'Tướng', 'Tử', 'Tù', 'Hưu'],
      ['Vượng', 'Tướng', 'Tử', 'Tù', 'Hưu']
    ]
  },
  {
    chiId: 5,
    mua: 'Xuân',
    muaCss: 'color_moc',
    tk: 'Thanh Minh',
    time: [
      { min: 1, max: 9, canId: 2 },
      { min: 10, max: 12, canId: 10 },
      { min: 13, max: 30, canId: 5 }
    ],
    can: [
      ['Vượng', 'Tướng', 'Tử', 'Tù', 'Hưu'],
      ['Tướng', 'Tử', 'Tù', 'Hưu', 'Vượng'],
      ['Tù', 'Hưu', 'Vượng', 'Tướng', 'Tử']
    ]
  },
  {
    chiId: 6,
    mua: 'Hạ',
    muaCss: 'color_hoa',
    tk: 'Lập hạ',
    time: [
      { min: 1, max: 5, canId: 5 },
      { min: 6, max: 14, canId: 7 },
      { min: 15, max: 30, canId: 3 }
    ],
    can: [
      ['Tù', 'Hưu', 'Vượng', 'Tướng', 'Tử'],
      ['Tử', 'Tù', 'Hưu', 'Vượng', 'Tướng'],
      ['Hưu', 'Vượng', 'Tướng', 'Tử', 'Tù']
    ]
  },
  {
    chiId: 7,
    mua: 'Hạ',
    muaCss: 'color_hoa',
    tk: 'Mang chủng',
    time: [
      { min: 1, max: 10, canId: 3 },
      { min: 11, max: 19, canId: 6 },
      { min: 20, max: 30, canId: 4 }
    ],
    can: [
      ['Hưu', 'Vượng', 'Tướng', 'Tử', 'Tù'],
      ['Tù', 'Hưu', 'Vượng', 'Tướng', 'Tử'],
      ['Hưu', 'Vượng', 'Tướng', 'Tử', 'Tù']
    ]
  },
  {
    chiId: 8,
    mua: 'Hạ',
    muaCss: 'color_hoa',
    tk: 'Tiểu thử',
    time: [
      { min: 1, max: 9, canId: 4 },
      { min: 10, max: 12, canId: 2 },
      { min: 13, max: 30, canId: 6 }
    ],
    can: [
      ['Hưu', 'Vượng', 'Tướng', 'Tử', 'Tù'],
      ['Vượng', 'Tướng', 'Tử', 'Tù', 'Hưu'],
      ['Tù', 'Hưu', 'Vượng', 'Tướng', 'Tử']
    ]
  },
  {
    chiId: 9,
    mua: 'Thu',
    muaCss: 'color_kim',
    tk: 'Lập thu',
    time: [
      { min: 1, max: 7, canId: 6 },
      { min: 8, max: 10, canId: 5 },
      { min: 11, max: 13, canId: 9 },
      { min: 14, max: 30, canId: 7 }
    ],
    can: [
      ['Tù', 'Hưu', 'Vượng', 'Tướng', 'Tử'],
      ['Tù', 'Hưu', 'Vượng', 'Tướng', 'Tử'],
      ['Tướng', 'Tử', 'Tù', 'Hưu', 'Vượng'],
      ['Tử', 'Tù', 'Hưu', 'Vượng', 'Tướng']
    ]
  },
  {
    chiId: 10,
    mua: 'Thu',
    muaCss: 'color_kim',
    tk: 'Bạch lộ',
    time: [
      { min: 1, max: 10, canId: 7 },
      { min: 11, max: 30, canId: 8 }
    ],
    can: [
      ['Tử', 'Tù', 'Hưu', 'Vượng', 'Tướng'],
      ['Tử', 'Tù', 'Hưu', 'Vượng', 'Tướng']
    ]
  },
  {
    chiId: 11,
    mua: 'Thu',
    muaCss: 'color_kim',
    tk: 'Hàn lộ',
    time: [
      { min: 1, max: 9, canId: 8 },
      { min: 10, max: 12, canId: 4 },
      { min: 13, max: 30, canId: 5 }
    ],
    can: [
      ['Tử', 'Tù', 'Hưu', 'Vượng', 'Tướng'],
      ['Hưu', 'Vượng', 'Tướng', 'Tử', 'Tù'],
      ['Tù', 'Hưu', 'Vượng', 'Tướng', 'Tử']
    ]
  },
  {
    chiId: 12,
    mua: 'Đông',
    muaCss: 'color_thuy',
    tk: 'Lập đông',
    time: [
      { min: 1, max: 8, canId: 4 },
      { min: 9, max: 12, canId: 1 },
      { min: 13, max: 30, canId: 9 }
    ],
    can: [
      ['Tù', 'Hưu', 'Vượng', 'Tướng', 'Tử'],
      ['Vượng', 'Tướng', 'Tử', 'Tù', 'Hưu'],
      ['Tướng', 'Tử', 'Tù', 'Hưu', 'Vượng']
    ]
  }
]
